/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLanguageRequest
 */
export interface CreateLanguageRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLanguageRequest
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLanguageRequest
     */
    from: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLanguageRequest
     */
    autoTranslate?: boolean;
}

/**
 * Check if a given object implements the CreateLanguageRequest interface.
 */
export function instanceOfCreateLanguageRequest(value: object): value is CreateLanguageRequest {
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    return true;
}

export function CreateLanguageRequestFromJSON(json: any): CreateLanguageRequest {
    return CreateLanguageRequestFromJSONTyped(json, false);
}

export function CreateLanguageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLanguageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'to': json['to'],
        'from': json['from'],
        'autoTranslate': json['autoTranslate'] == null ? undefined : json['autoTranslate'],
    };
}

export function CreateLanguageRequestToJSON(json: any): CreateLanguageRequest {
    return CreateLanguageRequestToJSONTyped(json, false);
}

export function CreateLanguageRequestToJSONTyped(value?: CreateLanguageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'to': value['to'],
        'from': value['from'],
        'autoTranslate': value['autoTranslate'],
    };
}

